export const aboutData = {
  title: "Who I am",
  description1:
    "Hello! My name is Najd Feki. I'm a web development engineer based in Tunisia.",
  description2:
    "A Full stack developer adept at all stages of advanced web development. Experienced with the latest state-of-the-art development tools and procedures. Able to effectively self-manage independent projects, as well as collaborate within a productive team .",
  image: 2,
};
